import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import exitDark from "../../../../images/exit.svg";
import exit from "../../../../images/exit.svg";
import back from "../../../../images/back.svg";
import { IKioskModel, IkioskManager } from "../../../../models/kioskModel";
import {
  backActionRequest,
  cancelAllPendingRequests,
  exitAction,
} from "../../../../store/actions";
import "../../Kiosk.css";

import lady from "../../../../images/kiosk/lady2.gif";
import bottom_bg from "../../../../images/kiosk/bottom_bg.svg";
import AutoPlayAudioPlayer from "./audioplay";
import { Ilanguages } from "../../../../models/utilitiesModel";

const ThemeOneFooter: React.FC = () => {
  // Function to get the appropriate image based on body class
  const getExitButton = (): string => {
    const bodyClass = document.body.className;
    // You can add more conditions based on your theme classes
    switch (true) {
      case bodyClass.includes("blue"):
        return exit;
      case bodyClass.includes("dark"):
        return exit;
      case bodyClass.includes("light"):
        return exitDark;
      default:
        return exit; // Default image
    }
  };
  const { t } = useTranslation("translations");
  const selectionArea = useSelector((state: any) => {
    if (state?.kioskReducer?.selectedArea)
      return (state.kioskReducer as IKioskModel).selectedArea;
    else return IkioskManager.HOME;
  });
  const language = useSelector((state: any) => {
    if (state?.kioskReducer?.language)
      return (state.kioskReducer as IKioskModel).language;
    else return "";
  });

  const emiratesData: any = useSelector(
    (state: any) => (state.kioskReducer as IKioskModel)?.emiratesData
  );
  const nameOfuser =
    language === Ilanguages.ENG
      ? `${emiratesData?.enName?.split(",")?.[0]} ${
          emiratesData?.enName?.split(",")?.[1]
        }`
      : `${emiratesData?.arName?.split(",")?.[0]} ${
          emiratesData?.arName?.split(",")?.[1]
        }`;

  console.log("ThemeOneFooter =>", selectionArea, language);
  const dispatch = useDispatch();

  const backButtonVisiblity = () => {
    if (
      [
        IkioskManager.EMIRADESVERIFICATION,
        IkioskManager.EXISTPATIENTJOUNEYPAGE,
        IkioskManager.APPOINTMENTSAREA,
        IkioskManager.TOKENAREA,
      ].includes(selectionArea)
    ) {
      return true;
    } else return false;
  };

  const getText = () => {
    if (IkioskManager.APPOINTMENTSAREA) {
      return t(`Kiosk.${gifText()?.text}` + language).replace(
        "{name}",
        emiratesData ? nameOfuser : ""
      );
    } else return t(`Kiosk.${gifText()?.text}` + language);
  };

  const ladygifVisible = () => {
    if (
      [
        IkioskManager.HOME,
        IkioskManager.APPOINTMENTSAREA,
        IkioskManager.LOADAPPOINTMENTS,
        IkioskManager.PATIENTJOUNEYEXPLORE,
        IkioskManager.EXISTPATIENTJOUNEYPAGE,
      ].includes(selectionArea)
    ) {
      return true;
    } else return false;
  };

  const gifText = () => {
    switch (selectionArea) {
      case IkioskManager.HOME:
        return { text: "langSelect", audio: "fp002" };
      case IkioskManager.EXISTPATIENTJOUNEYPAGE:
        return { text: "", audio: "fp-004" };
      case IkioskManager.PATIENTJOUNEYEXPLORE:
        return { text: "jouneystart", audio: "fp-003" };
      case IkioskManager.APPOINTMENTSAREA:
        return { text: "appointmentstext", audio: "fp-006" };
      case IkioskManager.LOADAPPOINTMENTS:
        return { text: "fetchMes", audio: "fp-005" };
      default:
        return;
    }
  };

  return (
    <>
      <div className="kiosk-footer">
        {![
          IkioskManager.EMIRADESVERIFICATION,
          IkioskManager.MRNVERIFICATION,
        ]?.includes(selectionArea) && (
          <div className="content-sec">
            <div
              className="welcometext"
              style={
                selectionArea === IkioskManager.TOKENAREA
                  ? { display: "none" }
                  : {}
              }
            >
              <div className="bottom_sec">
                <img
                  style={
                    selectionArea !== IkioskManager.HOME
                      ? { visibility: "hidden" }
                      : {}
                  }
                  src={bottom_bg}
                  alt="bottom_bg"
                  className="bottom_bg"
                />
                {ladygifVisible() && (
                  <>
                    {gifText()?.text && (
                      <>
                        <div className="spell_content">{getText()}</div>
                        {/* {selectionArea === IkioskManager.APPOINTMENTSAREA && <div className="help-container">
                    <span className="help-text">Need help?</span>
                    <button className="help-button">Yes</button>
                  </div>} */}
                      </>
                    )}
                    <img src={lady} alt="lady_logo" className="lady_img" />
                    <AutoPlayAudioPlayer fileName={`${gifText()?.audio}`} />
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="">
          <div className="footerLeft">
            <div className="copyRight">
              &copy;{" "}
              {t("Kiosk.2020Vectramind" + language).replace(
                "{year}",
                moment().format("YYYY")
              )}
            </div>

            {selectionArea !== IkioskManager.HOME &&
              selectionArea !== IkioskManager.ERRORBLOCKAREA && (
                <div className="footre_imgs">
                  {backButtonVisiblity() && (
                    <>
                      <img
                        src={back}
                        alt=""
                        width="55"
                        onClick={() => {
                          dispatch(backActionRequest());
                          dispatch(cancelAllPendingRequests());
                        }}
                      />
                      {/* back */}
                    </>
                  )}
                  <img
                    src={getExitButton()}
                    alt=""
                    width="55"
                    onClick={() => {
                      dispatch(exitAction());
                      dispatch(cancelAllPendingRequests());
                    }}
                  />

                  {/* <span className="exit-text"> </span> */}
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  );
};
export default React.memo(ThemeOneFooter);
